import { FaCheckCircle } from "react-icons/fa";

const ServiceOverview = ({ service }) => {
  return (
    <section className="py-24 bg-white">
      <div className="container-custom">

        <div className="grid lg:grid-cols-2 gap-16 items-center">

          <div>
            <img
              src={service.image}
              alt={service.title}
              className="w-full rounded-3xl shadow-xl"
            />
          </div>

          <div>

            <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
              Service Overview
            </span>

            <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
              Professional {service.title}
            </h2>

            <p className="text-gray-600 mt-8 leading-8">
              {service.overview}
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mt-10">

              {service.features.slice(0, 4).map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3"
                >
                  <FaCheckCircle className="text-[#F59E0B]" />
                  <span>{item}</span>
                </div>
              ))}

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default ServiceOverview;